import { createContext, useContext, useState, useEffect } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("mfi-lang") || "en");
  useEffect(() => {
    localStorage.setItem("mfi-lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);
  const t = translations[lang] || translations.en;
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
